import { useMutation, useQueryClient } from "react-query";
import { mutateDeleteFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";
import { Auth } from "../../interface";

export const useDeleteOwnerUser = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never>(
    (data) => mutateDeleteFn(ENDPOINTS.OWNER_ACCOUNT_DELETE, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([]);
      },
    }
  );
};
